// extracted by mini-css-extract-plugin
export default {"chat":"ChatComponent_chat__OqOy4"};